import {
  Channel,
  CHANNELS,
  EnvironmentType,
  ENVIRONMENT_TYPES,
} from 'types/customer';

/**
 * 顧客情報登録フォームのフィールド
 */
export type CustomerFormFields = {
  /** 顧客名 */
  name: string;
  /** 顧客詳細 */
  detail: string;
  /** 環境 */
  environment: string;
  /** 環境種別 */
  environmentType: EnvironmentType;
  /** 顧客番号 */
  corporateNumber: string;
  /** 契約種別 */
  channel: Channel;
  /** 顧客環境URL */
  poseidonUrl: string;
  /** 顧客ステータス */
  status: boolean;
  /** システム管理上のグループ */
  systemUpdateGroup: string;
  /** IAP Client ID */
  iapClientId: string;
  /** IAP Client Secret */
  iapClientSecret: string;
  /** システムの現在バージョン */
  currentSystemVersion: string;
  /** システムの次回バージョン */
  targetSystemVersion: string;
  /** Poseidon Agent CPU */
  poseidonAgentCpu: string;
  /** Poseidon Agent Memory */
  poseidonAgentMemory: string;
  /** VPA有効フラグ */
  enableVerticalPodAutoScaler: boolean;
};

/**
 * 顧客情報登録フォームのフィールドの初期値
 */
export const initCustomerFormFields: CustomerFormFields = {
  name: '',
  detail: '',
  environment: '',
  environmentType: ENVIRONMENT_TYPES.GCP,
  corporateNumber: '',
  channel: CHANNELS.STABLE,
  poseidonUrl: '',
  status: true,
  systemUpdateGroup: 'general',
  iapClientId: '',
  iapClientSecret: '',
  currentSystemVersion: '',
  targetSystemVersion: '',
  poseidonAgentCpu: '100m',
  poseidonAgentMemory: '141Mi',
  enableVerticalPodAutoScaler: false,
};
